import { getGradeBandForGrade, SUBMISSION_STATUSES, SUCCESS_SKILLS_STANDARDS_BY_BAND } from './successSkillsSubmission';

export const TIMELINESS_STANDARDS = Object.fromEntries(
  Object.entries(SUCCESS_SKILLS_STANDARDS_BY_BAND).map(([band, standards]) => [band, standards[0].code]),
);

export function timelinessStandard(grade) {
  return TIMELINESS_STANDARDS[getGradeBandForGrade(grade)] || null;
}

export function timelinessComponents(assignment) {
  if (!assignment.timeliness?.enabled) return [];
  if (assignment.timeliness.scope !== 'components') return [{ key: 'task', label: 'Whole task' }];
  return (assignment.standards || [])
    .filter((standard) => assignment.timeliness.standardCodes?.includes(standard.mlsCode))
    .map((standard) => ({ key: standard.mlsCode, label: standard.mlsCode }));
}

export function submissionStatusFor(assignment, studentId, component) {
  const status = assignment.submissionStatuses?.[studentId]?.[component] || 'on_time';
  const config = SUBMISSION_STATUSES.find((item) => item.id === status);
  if (!config) throw new Error(`Invalid submission status for student ${studentId}: ${status}`);
  return config;
}

export function hasRecordedGrade(cell) {
  return Boolean(cell && !cell.isMissing && cell.score !== 'M'
    && !cell.notAssessed && cell.score !== 'NA' && cell.score !== ''
    && cell.score != null && Number.isFinite(Number(cell.score)));
}

export function timelinessIsReady(assignment, grades, studentId, component) {
  if (assignment.submissionStatuses?.[studentId]?.[component] === 'incomplete') return true;
  if (component !== 'task') return hasRecordedGrade(grades?.[studentId]?.[component]);
  return (assignment.standards || []).some((standard) => hasRecordedGrade(grades?.[studentId]?.[standard.mlsCode]));
}
